<template>
  <div v-editable="blok" class="title-container">
    <component :is="blok.size || 'h1'" :style="customStyle" class="title">
      {{ blok.title }}
    </component>
  </div>
</template>

<script setup lang="ts">
import { StoryblokTitleBlok } from '@/features/storyblok/types';
import { computed } from 'vue';

const props = defineProps<{
  blok: StoryblokTitleBlok;
}>();
const customStyle = computed(() => {
  let formattedStyles = '';
  if (props.blok.titleStyle.includes('underline')) {
    formattedStyles += 'text-decoration: underline;';
  }
  if (props.blok.titleStyle.includes('bold')) {
    formattedStyles += 'font-weight: bold;';
  }
  if (props.blok.titleStyle.includes('italic')) {
    formattedStyles += 'font-style: italic;';
  }
  if (props.blok.titleStyle.includes('uppercase')) {
    formattedStyles += 'text-transform: uppercase;';
  }
  return formattedStyles;
});
</script>

<style scoped>
.title-container {
  display: flex;
  flex-direction: column;
  background: var(--ion-background-color);
  color: var(--ion-text-color);
}
.title {
  margin: 0;
  justify-content: center;
}

.title:where(h1) {
  font-size: 3rem;
}

.title:where(h2) {
  font-size: 2.5rem;
}

.title:where(h3) {
  font-size: 2rem;
}

.title:where(h4) {
  font-size: 1.75rem;
}

.title:where(h5) {
  font-size: 1.5rem;
}

.underline {
  text-decoration: underline;
}
</style>
